import { callFunction } from '@/lib/api';

export type PatientMessageEmailResult =
  | { sent: true; messageId: string | null }
  | { sent: false; reason: string };

/** Fire-and-forget notification. The portal message is already stored. */
export function sendStaffPatientMessageEmail(messageId: string): void {
  void callFunction<{ message_id: string }, PatientMessageEmailResult>(
    'send-patient-message-email',
    { message_id: messageId },
  ).catch((err: unknown) => {
    console.error('Failed to send patient message email:', err);
  });
}
